import { useContext, useEffect, useState } from 'react'
import { PPlanningTrainPage } from 'libs/raas-ui-react-components/src/components';
import PrivatePagesWrapper from 'components/PrivatePagesWrapper/PrivatePagesWrapper';
import { useNavigate } from 'react-router-dom';
import {  IStation, PlanningObject } from './TrainFlowPlanner.model';
import { removeItemStorage, setItemStorage } from 'services/util/sessionStorage.service';
import {  SessionStorageItems, getBodyLongMover, setBodyLongMover } from 'services/user/user.session.service';
import { ITripSelectedDetails } from 'models/TripInterface';
import useSession from 'hooks/useSession';
import useToast from 'hooks/useToast';
import { PlannerBoxLiterals } from './TrainFlowPlanner.aux';
import { useTranslation } from 'react-i18next';
import { getInformationStationsApi, mapPlanningObject } from './TrainFlowPlanner.service';
import { diasDiciembre,diasNoviembre } from './TrainFlowPlanner.mock';
import UtilContext from 'contexts/util.context';
import { closeRequest } from 'services/util/loader.service';
import { getNotificationsCall } from '../Planner/PlannerFlow.service';
import { INotifications } from '../Planner/PlannerFlow.model';
declare const window: any;
export const TrainFlowPlanner = () => {
    const navigate = useNavigate();
    const { setTripSelectedDetails, setReturnTripSelectedDetails } = useSession();
    const [initialBody, setInitialBody] = useState(null);
	const [calendarDays, setCalendarDays] = useState(null as any);
    const { openToast } = useToast();
    const [t, i18n] = useTranslation("trainPlannerFlow");
    const { setShowLoader } = useContext( UtilContext );
    const bodySearch =getBodyLongMover();
    let lenguage = "";
    const planingPageLiterals = {desc: t("planingPageLiterals.desc"),title: t("planingPageLiterals.title")}
    //const planingBoxLiterals = PlannerBoxLiterals(t) as any;
     const [notificationsBanner, setNotificationsBanner] = useState({} as INotifications);

    const [planingBoxLiterals, setPlaningBoxLiterals] = useState(PlannerBoxLiterals(t));

    useEffect(() => {
        !!sessionStorage?.getItem('current-page') && sessionStorage?.removeItem('current-page');
    }, [])


    useEffect(() => {
        if (sessionStorage.getItem('raas-language') != lenguage) {
            lenguage = sessionStorage.getItem('raas-language') as any
            setPlaningBoxLiterals(PlannerBoxLiterals(t))
               geyNotifications();
        }
   
    }, [t]);






    useEffect(() => {
        setTripSelectedDetails({} as ITripSelectedDetails);
        setReturnTripSelectedDetails({} as ITripSelectedDetails);
        removeItemStorage(SessionStorageItems.TRIP);
        removeItemStorage(SessionStorageItems.RAAS_TRIP_SUMMARY_DETAIL);
        removeItemStorage(SessionStorageItems.RAAS_RETURN_TRIP_SUMMARY_DETAIL);
     

    }, []);


    const toTripSelector = (e: any) => {
        const query = e.detail;


        const { ok, msg } = checkBookingDates(query, t);
        if (ok) {
            setPlanObject(query);
        } else {
            openToast("error", t("literals.error"), msg);
        }
    }

    const setPlanObject = (obj: any) => {
        const objMapped: PlanningObject = mapPlanningObject(obj);
        let dateDeparture= new Date(objMapped.departureDate.value);
        const numberNextDayDate = dateDeparture.setDate(dateDeparture.getDate());

   const string = new Date(numberNextDayDate).toISOString();
        const data={
            ...objMapped,
            departureDate:{
                "value": string,
                "invalid": false
            }
        }
        setItemStorage(SessionStorageItems.TRIP, data);
        let date= new Date(objMapped.departureDate.value);

        /*const aux={
            ...bodySearch,
            month:((date.getMonth() + 1) < 10 ? '0' : '')+ (date.getMonth() + 1),
            year:date.getFullYear().toString()
          }
    

        setBodyLongMover(aux)*/
        window.dataLayer?.push({
            event: "select_content",
            screen_name: 'home',
            screen_class: 'home',
            content_type: 'search',
            content_name: 'destination_search',
            journey_origin:	'home',
            journey_search: 'home'

        });
        navigate("/trip-train");
    }

    /**
     * obtenemos precios de las estaciones
     * @param obj Estaciones de origin y destinos
     */
    const getInformationStations = (body: any) => {
        //setInitialBody(obj)
        setShowLoader(false)
        closeRequest();
        if(body?.destination?.invalid==false && body?.origin?.invalid==false){
            getInformationStationsApi(body,
            (response: IStation) => {
                let aux={
                    ...response,
                    idItem:body.idItem
                }
                setCalendarDays(aux);
                
            },
            (err: any) => {
                setShowLoader(false)
                openToast("error", t("literals.errorTryAgainLater"), `${err?.status}`);
 
            }
        ,  window.sessionStorage["raas-trip-mock"])
        }
    }


    const getInformationStationsMonths = (body: any) => {
        //setCalendarDays(null)
        let bodyAux=null as any
        //Solo cambiamos fecha
            const date =new Date(body.viewDate);
            bodyAux={
                ...initialBody as any,
                month: ((date.getMonth() + 1) < 10 ? '0' : '')+ (date.getMonth() + 1),
                year:date.getFullYear().toString(),

            }
            setBodyLongMover(bodyAux)
     if(bodyAux?.destination?.invalid==false && bodyAux?.origin?.invalid==false){
        getInformationStationsApi(bodyAux,
            (response: IStation) => {
                let aux={
                    ...response,
                    idItem:body.idItem
                }
                setCalendarDays(aux);
             
            },
            (err: any) => {
                openToast("error", t("literals.errorTryAgainLater"), `${err?.status}`);
            }
        ,  window.sessionStorage["raas-trip-mock"])
     }
    }

    const setData = (e: any) => {
        if(e.detail){
            setInitialBody(e.detail);
            setBodyLongMover(e.detail)
        }
    
    }

        const geyNotifications = () => {
            getNotificationsCall(
                (data: any) => {
                    setNotificationsBanner(data.data.homeMessage)
                },
                () => {
                      setNotificationsBanner(null as any)
                }
            );
        }
    
    return (
        <>
         
        <PPlanningTrainPage 
            notificationsBanner={notificationsBanner}
            initialBody={initialBody}
            literals={planingPageLiterals}
            boxliterals={planingBoxLiterals as any} 
            onGoPlanningEvent={toTripSelector}
            onGetSelectedStationsEvent={(e)=>getInformationStations(e.detail)}
            calendarDays={calendarDays}
            isOnlyTrain={true}
            onChangeMonth={(e)=>getInformationStationsMonths(e.detail)}
            onBodyStations={(e)=>
                setData(e)}
             />
            <PrivatePagesWrapper></PrivatePagesWrapper>
        </>
    )
}



export const checkBookingDates = (details: any, t?: any, inverse?: boolean) => {
    let ok = true;
    let msg = "";
    let { hours, minutes } = details?.departureSchedule?.value;
    let departureDate = new Date(details?.departureDate?.value);


    //let departureFullDate = new Date(departureDate.getFullYear(), departureDate.getMonth(), departureDate.getDate(), parseInt(hours), parseInt(minutes));
    let actualDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), new Date().getHours(), new Date().getMinutes());
    if (!details.return) {
        //ok = departureDate >= actualDate;
        ok=true
        //if (!ok) msg = t("literals.previousDepartureDateCurrentDate");
    } else {
        hours = details?.arrivalSchedule?.value.hours;
        minutes = details?.arrivalSchedule?.value.minutes;
        let arrivalDate = new Date(details?.arrivalDate?.value);
        let getHoras=departureDate.getHours();
        arrivalDate.setHours(getHoras+1)
        //arrivalDate.setMinutes(58);
        //let arrivalFullDate = new Date(arrivalDate.getFullYear(), arrivalDate.getMonth(), arrivalDate.getDate(), parseInt(hours), parseInt(minutes));
        ok = (arrivalDate >= departureDate) //&& (departureDate >= actualDate);
        if (!(arrivalDate > departureDate)) msg = t("literals.previousArrivalDateDepartureDate");
        if (inverse && (arrivalDate > departureDate)) msg = t("literals.previousArrivalDateDepartureDate");
        if (!(departureDate >= actualDate)) msg = t("literals.previousDepartureDateCurrentDate");
    }

    return { ok: inverse ? !ok : ok, msg };
}


